import { postJson } from "../methods";
function gridFilters(options, include = "info,score,analysis", headers = {}) {
  const defaultOptions = {
    no_result_if_limit: false,
    offset: 0,
    size: 16,
    state: "read"
  };
  return postJson({
    url: `api/grid/filter?include=${include}`,
    payload: {
      ...defaultOptions,
      ...options
    },
    headers
  });
}
export {
  gridFilters as default
};
